import React, { createContext, useMemo, useState } from 'react';

interface LookbackContextProps {
  lookback: string;
  setLookback: React.Dispatch<React.SetStateAction<string>>;
}

const LookbackContext = createContext<LookbackContextProps>({
  lookback: '-15m',
  setLookback: () => '-15m',
});

export function LookbackProvider({ children }: { children: React.ReactNode }) {
  const [lookback, setLookback] = useState<string>('-15m');

  const value = useMemo(() => ({ lookback, setLookback }), [lookback]);

  return (
    <LookbackContext.Provider value={value}>
      {children}
    </LookbackContext.Provider>
  );
}

export default LookbackContext;
